// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"251f43bd","124":"37d3572a","589":"b96111af","596":"a075f95c"}[chunkId] + ".chunk.js";
};